import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TabComponent } from '@syncfusion/ej2-angular-navigations';
import { AuthenService } from '../../services/authen.service';
import { PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { DataManager } from '@syncfusion/ej2-data';
import { HttpService } from '../../services/http.service';
import { HelperService } from '../../services/helper.service';
import { MyDataAdaptor } from '../../helpers/grid.adaptor';
import * as AppConst from '../../data/test.data';
import { ReportParaFilter } from '../../models/report/report-para-filter.model';
import { CustListString } from '../../models/report/cust-list-string.model';
import { DatePipe } from '@angular/common';
import { MultiSelectCust } from '../../models/report/multi-select-cust.model';
import { GridComponent, ToolbarItems, ExcelExportProperties } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { Alert } from 'selenium-webdriver';
import { saveAs as importedSaveAs } from "file-saver";

@Component({
    selector: '',
    templateUrl: './report-summary-request.html',
    //styleUrls: ['./report-request-detail.less']
})
export class ReportSummaryRequestComponent implements OnInit {

    public lstPrnStr: string = '';
    public show: boolean = false;

    statusReport: Array<any> = ['All', 'Open', 'Waiting for principal approve', 'Principal approved', 'Waiting tender result', 'Win', 'Lost', 'Cancel'];
    //Area: Array<any> = ['All', 'HCM', 'HN', 'SOU', 'NOR', 'MEK', 'CEN'];
    //Detail: Array<any> = ['All', 'Tender', 'Renewal', 'Tender supplement', 'Price Application', 'Apply tender result', 'Direct purchase tender'];

    Area: Array<any> = [];
    Province: Array<any> = [];
    typeOfRequest: Array<any> = ['All', 'Áp giá thầu', 'Giữ giá ổn định', 'Gia hạn hiệu lực', ' Chỉ định thầu-không hồ sơ',
        'Chỉ định thầu - không hồ sơ - xin trước', 'Chỉ định thầu - Setup', 'Kết quả thầu - Setup or stop', 'Kết quả thầu - trước kết quả'
        , 'Setup Visa', ' Đổi code', 'Điều chuyển - Vượt quota', 'Hợp Đồng', 'Phụ lục hợp đồng', 'Thanh Lý',
        'Hợp Đồng-Nghiệm thu-Thanh lý tháng', 'Bảo lãnh', 'Báo giá kế hoạch', 'Thực hiện công văn',
        'Cung cấp HS tài liệu', 'Biên bản nghiệm thu'];
       
    dateFormat = "dd/MM/yyyy";
    public dateValueFrom: Date = new Date();
    public dateValueTo: Date = new Date();
    public statusReportSelected: string = '';
    public areaSelected: string = '';
    public provineSelected: string = '';
    public typeOfRequestSelected: string = '';
    public scCode: string = '';
    public ffmCode: string = '';
    public hsCode: string = '';

    public detailSelected: string = '';
    public empListPRN: Array<any> = [];
    public empListCust: Array<any> = [];

    public strFromYear: string = '';
    public strToYear: string = '';
    public strFromMonth: string = '';
    public strToMonth: string = '';

    //public dataPRN: string[] = ['All', 'A14', 'A05', 'A09', 'A12', 'A15', 'A17', 'A18', 'A19', 'A20', 'B01', 'B14', 'B15', 'B16', 'B17', 'B04', 'B06', 'B07', 'D01', 'E04', 'F02', 'F03', 'G03', 'G06', 'G10', 'H02', 'I01', 'J04', 'K01', 'L01', 'M03', 'M04', 'M18', 'M07', 'M19', 'M09', 'N12', 'N13', 'N16', 'N17', 'N18', 'N21', 'N23', 'P04', 'P10', 'P12', 'P09', 'S13', 'S27', 'S28', 'S29', 'S30', 'S31', 'S32', 'S34', 'T02'];

    //public fields: string[] = [];
    //public custMTS: Array<MultiSelectCust> = [];
    reportParaFilter = new ReportParaFilter();

    // set placeholder to MultiSelect input element
    public placeholder: string = 'Select Principal';
    public placeholderCust: string = 'Select Customer';
    public placeholderItem: string = 'Select Item'

    //// maps the appropriate column to fields property
    //public fields: Object = { text: 'label', value: 'value' };
    //public sorting: string = 'Ascending';
    //public commentData: Object = { id: '', sports: '' };

    public dataReport: DataManager;
    public toolbarOptions: ToolbarItems[];
    @ViewChild('grid') public grid: GridComponent;

    public pageSettings: PageSettingsModel;

    //Autocomplete
    public dataAutocomplete: DataManager;
    public textAutocomplete: string = "Find a customer";
    public textCustSelected: string = "";

    //Autocomplete Item
    public dataAutocompleteItem: DataManager;
    public textAutocompleteItem: string = "Find a item";
    public textItemSelected: string = "";

    public dataAutocompleteSCCode: DataManager;
    public textAutocompleteSCCode: string = "Find a SC code";
    public textSCCodeSelected: string = "";

    public dataAutocompleteFFMCode: DataManager;
    public textAutocompleteFFMCode: string = "Find a FFM code";

    public dataAutocompleteHSCode: DataManager;
    public textAutocompleteHSCode: string = "Find a HS code";

    constructor(private http: HttpService, private helper: HelperService, private datePipe: DatePipe) {
        this.getCustMTS();
        //this.pageSettings = { pageSize: 200 };
    }

    ngOnInit(): void {
        //this.toolbarOptions = ['ExcelExport'];
    }

    toolbarClick(args: ClickEventArgs): void {
        if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
            const excelExportProperties: ExcelExportProperties = {
                fileName: 'Summary Procurement by SKU.xlsx'
            };
            this.grid.excelExport(excelExportProperties);
        }
    }

    getCustMTS() {
        this.http.get('api/Report/Get_SC_Code', res => {
            this.dataAutocompleteSCCode = res;
        }, null);

        this.http.get('api/Report/Get_FFM_Code', res => {
            this.dataAutocompleteFFMCode = res;
        }, null);

        this.http.get('api/Report/Get_HS_Code', res => {
            this.dataAutocompleteHSCode = res;
        }, null);

        this.http.get('api/Report/Get_Area_Code', res => {
            this.Area = res;
        }, null);

        this.http.get('api/Report/Get_Province_Code', res => {
            this.Province = res;
        }, null);


        //this.http.get('api/Report/GetCustMultiSelect', res => {
        //        this.custMTS = res;
        //        var allOption = new MultiSelectCust();
        //        allOption.label = "All";
        //        allOption.value = "All";
        //        this.custMTS.push(allOption);
        //    }, null);

        //    this.custMTS.forEach(function (value) {
        //        this.sportsData.push({ text: value.label.toString(), id: value.value.toString() });
        //        console.log(value.label.toString());
        //    });

        //this.http.get('api/Report/GetCustomerCodeAndName', res => {
        //    this.dataAutocomplete = res;
        //}, null);
    }

    onFilteringCust(event) {
        this.empListCust.push(event.value);
    }

    onFiltering(event) {
        this.empListPRN.push(event.value);
    }

    changeStatusReport(ev) {
        this.statusReportSelected = ev.value;
    }
    changeAreaReport(ev) {
        this.areaSelected = ev.value;
    }
    changeProvineReport(ev) {
        this.provineSelected = ev.value;
    }
    changeTypeRequest(ev) {
        this.typeOfRequestSelected = ev.value;
    }

    changeDetialReport(ev) {
        this.detailSelected = ev.value;
    }

    convertDateToString() {
        
        if (!this.statusReportSelected || 0 === this.statusReportSelected.length) {
            this.statusReportSelected = 'All';
        }

        if (!this.areaSelected || 0 === this.areaSelected.length) {
            this.areaSelected = 'All';
        }
        if (!this.provineSelected || 0 === this.provineSelected.length) {
            this.provineSelected = 'All';
        }
        if (!this.scCode || 0 === this.scCode.length) {
            this.scCode = 'All';
        }
        if (!this.ffmCode || 0 === this.ffmCode.length) {
            this.ffmCode = 'All';
        }
        if (!this.hsCode || 0 === this.hsCode.length) {
            this.hsCode = 'All';
        }
        //if (!this.detailSelected || 0 === this.detailSelected.length) {
        //    this.detailSelected = 'All';
        //}

        //if (!this.empListPRN || 0 === this.empListPRN.length) {
        //    this.lstPrnStr = 'All';
        //}
        //else {
        //    this.lstPrnStr = this.empListPRN.join(";");
        //}

        //if (!this.textCustSelected || 0 === this.textCustSelected.length) {
        //    this.textCustSelected = "All";
        //}
        //else if (this.textCustSelected.includes(" = ")) {
        //    this.textCustSelected = this.textCustSelected.split(" = ")[2];
        //}

        //if (!this.textItemSelected || 0 === this.textItemSelected.length) {
        //    this.textItemSelected = "All";
        //}
        //else if (this.textItemSelected.includes(" = ")) {
        //    this.textItemSelected = this.textItemSelected.split(" = ")[1];
        //}

        let fromDate = this.datePipe.transform(this.dateValueFrom, 'yyyyMMdd');
        let toDate = this.datePipe.transform(this.dateValueTo, 'yyyyMMdd');
        this.strFromYear = fromDate.substring(0, 4);
        this.strToYear = toDate.substring(0, 4);
        this.strFromMonth = fromDate.substring(4, 6);
        this.strToMonth = toDate.substring(4, 6);

        this.reportParaFilter.FromMonth = this.strFromMonth;
        this.reportParaFilter.FromYear = this.strFromYear;
        this.reportParaFilter.ToMonth = this.strToMonth;
        this.reportParaFilter.ToYear = this.strToYear;
       // this.reportParaFilter.Status = this.statusReportSelected;
        //this.reportParaFilter.Area = this.areaSelected;
        //this.reportParaFilter.Detail = this.detailSelected;
        //this.reportParaFilter.Principal = this.lstPrnStr;
        //this.reportParaFilter.CustCode = this.textCustSelected;
        //this.reportParaFilter.ItemCode = this.textItemSelected;
    }
    //onExportClick() {
    //    alert('aaaa');
    //    this.convertDateToString();
        
    //    this.dataReport = new DataManager({ url: `${this.http.baseUrl}api/Report/GetPageReportBySku?FromMonth=${this.reportParaFilter.FromMonth}&FromYear=${this.reportParaFilter.FromYear}&ToMonth=${this.reportParaFilter.ToMonth}&ToYear=${this.reportParaFilter.ToYear}`, adaptor: new MyDataAdaptor(this.helper), crossDomain: true });
    //    alert('aaaa6');
    //}

    onExportClick() {
        var element = <HTMLInputElement>document.getElementById("btnExcel");
        element.disabled = true;
        this.convertDateToString();

        //this.show = true;
        //this.http.download(`api/Report/ExportVS_ReportBySKU?FromMonth=${this.reportParaFilter.FromMonth}&FromYear=${this.reportParaFilter.FromYear}&ToMonth=${this.reportParaFilter.ToMonth}&ToYear=${this.reportParaFilter.ToYear}&Status=${this.reportParaFilter.Status}&Area=${this.reportParaFilter.Area}&Detail=${this.reportParaFilter.Detail}&Principal=${this.reportParaFilter.Principal}&CustCode=${this.reportParaFilter.CustCode}&ItemCode=${this.reportParaFilter.ItemCode}&fromDate=${this.datePipe.transform(this.dateValueFrom, 'yyyy-MM-dd')}&toDate=${this.datePipe.transform(this.dateValueTo, 'yyyy-MM-dd')}`, res => {
        //    importedSaveAs(res, "Summary Procurement by SKU.xlsx");
        //    this.show = false;
        //    element.disabled = false;
        //});

        this.show = true;
        this.http.download(`api/Report/GetSummaryRequest?FromMonth=${this.reportParaFilter.FromMonth}&FromYear=${this.reportParaFilter.FromYear}&ToMonth=${this.reportParaFilter.ToMonth}&ToYear=${this.reportParaFilter.ToYear}&Area=${this.areaSelected}&Provine=${this.provineSelected}&scCode=${this.scCode}&ffmCode=${this.ffmCode}&hsCode=${this.hsCode}`, res => {
            importedSaveAs(res, "Sumary Of Request.xlsx");
            this.show = false;
            element.disabled = false;
        });


    }
    onActionFailure(e: Error): void {
        this.helper.alert(e.message);
    }
}


